import { List } from "@/shared/components/GenericSearchBar/model/List";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FILE } from "@/shared/constants/FileConstants";
import {
  COLLECTIONS_NAME,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  FILE_NAME,
  MULTIMEDIA_ACCESS,
  MULTIMEDIA_CONSTANTS,
  MULTIMEDIA_ICONS_FILE_TYPE,
  NEW_FILE,
  TYPE_FILES
} from "../../constants/multimediaConstants";
import { MultimediaDTO } from "../../models/Multimedia.model";
import firebase from "firebase/app";
import "firebase/storage";
import { MultimediaService } from "../../services/MultimediaService";
import DocumentViewer from "@/shared/components/DocumentViewer/DocumentViewer.vue";
import { Utils } from "@/shared/utils/utils";
import ModalTemplate from "../../../../shared/components/ModalTemplate/ModalTemplate.vue";
import { AxiosError } from "axios";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";

@Component({
  name: "SaveFile",
  components: { DocumentViewer, ModalTemplate, DynamicSelect }
})
export default class SaveFile extends Vue {
  @Inject() multimediaService!: MultimediaService;

  @Prop() categories!: List[];
  @Prop() fileToEdit!: MultimediaDTO;
  @Prop() newFile!: boolean;
  @Prop({ default: false, required: false })
  public isModal!: boolean;

  saveMultimedia = false;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  isEditing = false;
  typeFiles = TYPE_FILES;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  FILE_NAME = FILE_NAME;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  TYPE_LABEL = MULTIMEDIA_CONSTANTS.TYPE_LABEL;
  CATEGORY_LABEL = MULTIMEDIA_CONSTANTS.CATEGORY_LABEL;
  multimediaFile: MultimediaDTO = { ...NEW_FILE };
  MULTIMEDIA_CONSTANTS = MULTIMEDIA_CONSTANTS;
  ACTIVO = MULTIMEDIA_CONSTANTS.ACTIVO;
  switchClass = STYLE_CLASSES.SWITCH;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  showModaViewFile = false;
  selectedFile: File = {} as File;
  formatAccept = "";
  fileName = "";
  fileType = "";
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  requiredFieldSelect = [FORM_VALIDATORS.REQUIRED_FILE];
  modalDialogFile = false;
  modalTextFile = "";
  modalTitleFile = "";
  action = "";
  saving = false;
  errorsName: string[] = [];
  MAX_FILE_SIZE = 10 * 1024 * 1024;

  typeFileConfigList: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: this.typeFiles.map(item => {
      return { id: item.key, name: item.name };
    }),
    messageLabel: this.TYPE_LABEL,
    hint: "",
    persistenthint: false,
    required: true
  };
  multimediaTypeModel = [{ id: "", name: "" }];

  categoryFileConfigList: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: this.categories.map(item => {
      return { id: item.key, name: item.name };
    }),
    messageLabel: this.CATEGORY_LABEL,
    hint: "",
    persistenthint: false,
    required: true
  };
  multimediaCategoryModel = [{ id: "", name: "" }];
  appendIconMediaFile = "";
  editStringComparation = "";
  invalidEdit = false;

  mounted() {
    if (this.fileToEdit._key !== "") {
      this.listenIfChangeFileToEdit();
    }
    this.goToStart(MULTIMEDIA_CONSTANTS.SAVE_FILE_FORM);
  }

  get multimediaType() {
    return this.multimediaTypeModel[0];
  }

  set multimediaType(data: { id: string; name: string }) {
    this.multimediaTypeModel = [data];
  }

  get multimediaCategory() {
    return this.multimediaCategoryModel[0];
  }

  set multimediaCategory(data: { id: string; name: string }) {
    this.multimediaCategoryModel = [data];
  }

  @Watch("multimediaTypeModel")
  listenChangeFileType() {
    if (this.multimediaType.id !== "" && !this.isEditing) {
      this.formatAccept = [...TYPE_FILES].find(
        item => item.key === this.multimediaType.id
      )!.formats;
      this.clearDocumentName();
    }
  }

  get disableView() {
    return this.multimediaFile.multimediaPath === "" ? true : false;
  }

  getFileUploaded(file?: File) {
    this.multimediaFile.multimediaPath = "";
    if (file && file.name) {
      if (file.size < this.MAX_FILE_SIZE) {
        this.selectedFile = file;
        this.splitName(file.name);
      } else {
        this.clearDocumentName();
        Snackbar.popWarning(MULTIMEDIA_CONSTANTS.INVALID_FILE_SIZE);
      }
    } else {
      this.clearDocumentName();
    }
  }

  splitName(fullName: string) {
    const array = fullName.split(".");
    const last = array.pop();

    if (last) {
      this.fileType = last.toLocaleLowerCase();
      if ((this.formatAccept, this.formatAccept.search(this.fileType) < 0)) {
        this.clearDocumentName();
        this.saving = false;
        Snackbar.popError(MULTIMEDIA_CONSTANTS.INVALID_FILE);
      } else {
        this.fileName = array.join(".");
      }
    } else {
      this.clearDocumentName();
    }
  }

  convertUrl(url: string) {
    try {
      const loc = new URL(url);
      if (loc.host === MULTIMEDIA_CONSTANTS.YOUTUBE_HOST) {
        return `${
          MULTIMEDIA_CONSTANTS.YOUTUBE_PATH_EMBED
        }/${loc.searchParams.get(MULTIMEDIA_CONSTANTS.V_PARAM_YOUTUBE)}`;
      }
      return url;
    } catch (error) {
      return MULTIMEDIA_CONSTANTS.INVALID_URL;
    }
  }

  clearDocumentName() {
    this.fileName = "";
    this.fileType = "";
    this.selectedFile = {} as File;
  }

  viewFile() {
    this.showModaViewFile = true;
  }

  uploadDocument() {
    this.saving = true;
    if (this.multimediaFile._key === "") {
      this.validateTypeUrl();
    } else {
      this.updateFile();
    }
  }

  async validateTypeUrl() {
    if (this.multimediaType.id === MULTIMEDIA_CONSTANTS.URL) {
      this.createMultimedia();
    } else {
      const fileCreated = await this.createMultimedia();

      if (fileCreated?.code === Http.Ok) {
        await this.uploadDocumentToCloud(
          fileCreated.data!,
          this.fileType,
          this.selectedFile
        );
      } else {
        this.saving = false;
        Snackbar.popError(fileCreated!.message);
      }
    }
  }

  async updateFile() {
    try {
      const body: MultimediaDTO = { ...this.multimediaFile };
      body.type = this.multimediaType.id;
      body.category = this.multimediaCategory.id;

      if (this.multimediaType.id === MULTIMEDIA_CONSTANTS.URL) {
        const urlConverted = this.convertUrl(
          this.multimediaFile.fieldName.trim()
        );
        if (urlConverted === MULTIMEDIA_CONSTANTS.INVALID_URL) {
          this.saving = false;
          Snackbar.popError(urlConverted);
          return;
        }
        body.multimediaPath = urlConverted;
      }
      const response = await this.multimediaService.updateFile(
        body,
        this.multimediaFile._key!
      );
      if (response.code === Http.Ok) {
        this.mustUpdateFile();
      } else {
        this.saving = false;
        Snackbar.popError(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + MULTIMEDIA_ACCESS.PUT
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      this.saving = false;
    }
  }

  async mustUpdateFile() {
    if (this.fileName !== "") {
      await this.deleteFileFromStorage(this.multimediaFile._key!);
      this.uploadDocumentToCloud(
        this.multimediaFile._key!,
        this.fileType,
        this.selectedFile
      );
    } else {
      this.saving = false;
      Snackbar.popSuccess(MULTIMEDIA_CONSTANTS.UPDATE_SUCCESS);
      this.cleanFields();
      this.$emit(MULTIMEDIA_CONSTANTS.SAVED_FILE);
    }
  }

  async createMultimedia() {
    try {
      const body: MultimediaDTO = { ...this.multimediaFile };
      body.type = this.multimediaType.id;
      body.category = this.multimediaCategory.id;
      if (this.multimediaType.id === MULTIMEDIA_CONSTANTS.URL) {
        const urlConverted = this.convertUrl(
          this.multimediaFile.fieldName.trim()
        );
        if (urlConverted === MULTIMEDIA_CONSTANTS.INVALID_URL) {
          this.saving = false;
          Snackbar.popError(urlConverted);
          return;
        }
        body.multimediaPath = urlConverted;
      }
      const response = await this.multimediaService.saveFile(body);
      if (response.code === Http.Ok) {
        if (this.multimediaType.id === MULTIMEDIA_CONSTANTS.URL) {
          this.cleanFields();
          this.$emit(MULTIMEDIA_CONSTANTS.SAVED_FILE);
        }
        return response;
      } else {
        this.saving = false;
        Snackbar.popError(response.message);
        return response;
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + MULTIMEDIA_ACCESS.POST
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      this.saving = false;
    }
  }

  async uploadDocumentToCloud(fileName: string, fileType: string, file: File) {
    try {
      const storageRef = firebase.storage().ref();

      const response = await storageRef
        .child(
          `${Utils.getClientStoragePath()}/${
            MULTIMEDIA_CONSTANTS.MULTIMEDIA_FOLDER
          }/${this.multimediaType.id}/${fileName}.${fileType}`
        )
        .put(file);

      if (response) {
        const filePath = (await response.ref.getDownloadURL()).toString();
        const body: MultimediaDTO = { ...this.multimediaFile };
        body.type = this.multimediaType.id;
        body.category = this.multimediaCategory.id;
        body.fieldName = this.selectedFile.name.trim();
        body.fieldSize = this.selectedFile.size.toString();
        body.multimediaPath = filePath;
        const updateResponse = await this.multimediaService.updateFile(
          body,
          fileName
        );
        if (updateResponse.code === Http.Ok) {
          this.saving = false;
          Snackbar.popSuccess(MULTIMEDIA_CONSTANTS.SAVE_SUCCESS);
          this.cleanFields();
          this.$emit(MULTIMEDIA_CONSTANTS.SAVED_FILE);
        } else {
          await this.deleteFileFromStorage(fileName);
          await this.deleteFailedFile(fileName);
        }
      } else {
        await this.deleteFailedFile(fileName);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + MULTIMEDIA_ACCESS.PUT
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      this.saving = false;
    }
  }

  async deleteFailedFile(documentId: string) {
    try {
      const response = await this.multimediaService.deleteFile(documentId);
      if (response.code === Http.Ok) {
        this.saving = false;
        Snackbar.popError(FILE.SNACKBAR.UPLOAD_FAILED);
      } else {
        this.saving = false;
        Snackbar.popError(FILE.SNACKBAR.DELETE_FAILED);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + MULTIMEDIA_ACCESS.DELETE
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async deleteFileFromStorage(fileName: string) {
    const arrayToGetExtension = this.multimediaFile.fieldName.split(".");
    const extensionFile = arrayToGetExtension[arrayToGetExtension.length - 1];
    try {
      const storageRef = firebase
        .storage()
        .ref(
          `${Utils.getClientStoragePath()}/${
            MULTIMEDIA_CONSTANTS.MULTIMEDIA_FOLDER
          }/${this.multimediaType.id}/${fileName}.${extensionFile}`
        );
      await storageRef.delete();
      this.saving = false;
    } catch (error) {
      this.saving = false;
      Snackbar.popError(FILE.SNACKBAR.DELETE_FAILED);
    }
  }

  confirmDialog(action: string) {
    if (this.saving) return;
    if (action === MULTIMEDIA_CONSTANTS.SAVE_FILE) {
      this.modalTextFile = MULTIMEDIA_CONSTANTS.SAVE_FILE_CONFIRMATION_TEXT;
      this.modalTitleFile = MULTIMEDIA_CONSTANTS.SAVE_FILE_CONFIRMATION_TITLE;
      this.modalDialogFile = true;
      return;
    }

    this.$emit(MULTIMEDIA_CONSTANTS.CANCEL_FILE);
  }

  closePreview() {
    this.showModaViewFile = false;
  }
  @Watch("fileName")
  @Watch("multimediaFile.state")
  checkEdit() {
    if (this.isEditing) {
      this.invalidEdit =
        JSON.stringify({
          state: this.multimediaFile.state,
          selectedFile: this.fileName
        }) === this.editStringComparation;
    }
  }
  @Watch("newFile")
  cleanFields() {
    this.isEditing = false;
    this.multimediaFile._key = "";
    this.multimediaTypeModel = [{ id: "", name: "" }];
    this.multimediaFile.multimediaPath = "";
    this.multimediaFile.name = "";
    this.multimediaFile.state = true;
    this.multimediaTypeModel = [{ id: "", name: "" }];
    this.multimediaFile.fieldName = "";
    this.multimediaFile.fieldSize = "";
    this.selectedFile = {} as File;
    this.formatAccept = "";
    this.fileName = "";
    this.fileType = "";
  }

  @Watch("fileToEdit._key")
  listenIfChangeFileToEdit() {
    this.cleanFields();
    if (this.fileToEdit._key !== "") {
      this.isEditing = true;
      this.multimediaFile._key = this.fileToEdit._key;
      const multimediaCategory = this.categories.find(
        category => category.key === this.fileToEdit.category
      );
      this.multimediaCategory = {
        id: multimediaCategory?.key ?? "",
        name: multimediaCategory?.name ?? ""
      };
      this.multimediaFile.multimediaPath = this.fileToEdit.multimediaPath;
      this.multimediaFile.name = this.fileToEdit.name.trim();
      this.multimediaFile.state = this.fileToEdit.state;
      const multimediaType = [...this.typeFiles].find(
        item => item.key === this.fileToEdit.type
      );
      this.multimediaType = {
        id: multimediaType?.key ?? "",
        name: multimediaType?.name ?? ""
      };
      this.multimediaFile.fieldName = this.fileToEdit.fieldName.trim();
      this.selectedFile = new File(
        [this.fileToEdit.fieldName.trim()],
        this.fileToEdit.fieldName.trim()
      );
      this.formatAccept = [...TYPE_FILES].find(
        item => item.key === this.multimediaType.id
      )!.formats;
      this.saveMultimedia = true;
      this.typeFileConfigList.disabled = true;
      this.categoryFileConfigList.disabled = true;
      this.invalidEdit = true;
      this.editStringComparation = JSON.stringify({
        state: this.multimediaFile.state,
        selectedFile: this.fileName
      });
    }
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  handleModalAccept() {
    this.uploadDocument();
    this.action = "";
    this.modalDialogFile = false;
  }

  handleModalCancel() {
    this.modalDialogFile = false;
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.MULTIMEDIA,
      this.multimediaFile.name
    );
  }

  @Watch("multimediaTypeModel", { deep: true })
  onChangeFileType() {
    this.appendIconMediaFile = MULTIMEDIA_ICONS_FILE_TYPE.IMAGEN;
    if (this.multimediaType.id == MULTIMEDIA_CONSTANTS.AUDIO_FILE) {
      this.appendIconMediaFile = MULTIMEDIA_ICONS_FILE_TYPE.AUDIO;
    }
  }
}
